import { ProfileContainer, NotificationContainer, SearchContainner, HelpContainer} from './TopBarComponets';
import './TopBar.css'
import { SBAComboBox } from '../../UiComponents/SBADropDown';
import { getCustomSettings } from '../../../config/apiConfig';
import React,{useState, useEffect} from 'react';
import { sbaAxios } from '../../utils/sbaAxios';

export const TopBar = ({ label, From }) => {
  const [knowledgeBase, setKnowledgeBase] = useState(true);
  const [globalVisible, setGlobalVisible] = useState(false);
  const getKnowledgeBaseSetting = async() => {
        try{
            const response = await sbaAxios({ url: `${getCustomSettings}1028` });
            if(response){
                const parsedResponse = JSON.parse(response.CustomSettingsValue);
                setKnowledgeBase(parsedResponse.knowledgeBase);
                setGlobalVisible(parsedResponse.globalSearch)
            }
        }
        catch(e){
            setKnowledgeBase(true);
            setGlobalVisible(false);
        }
    }
    useEffect(()=>{
      getKnowledgeBaseSetting();
    },[])
    return(
        <header className="navbar sticky-top bg-white flex-md-nowrap p-2 align-items-center" id="SbaTopBar">
            <h1 className="h4 w-100 fs-5 fw-semibold m-0 p-md-3">{label}</h1>             
                {globalVisible && <SearchContainner />}              
             
                {!knowledgeBase && 
                <>
                <NotificationContainer/>
                <HelpContainer/>
                <ProfileContainer />
                </>
                }           
             </header>
    )
};

export const HomePageTopBar=({options,familyList,selectedOption,optionChange,selectedFamily,setSelectedFamily,compositebuttonActive,portfoliobuttonActive,CompositeValue,PortfolioValue,Filtericon})=>{
  const [knowledgeBase, setKnowledgeBase] = useState(true);
  const [globalVisible, setGlobalVisible] = useState(false);
  const getKnowledgeBaseSetting = async() => {
        try{
            const response = await sbaAxios({ url: `${getCustomSettings}1028` });
            if(response){
                const parsedResponse = JSON.parse(response.CustomSettingsValue);
                setKnowledgeBase(parsedResponse.knowledgeBase);
                setGlobalVisible(parsedResponse.globalSearch)
            }
        }
        catch(e){
            setKnowledgeBase(true);
            setGlobalVisible(false);
        }
    }
    useEffect(()=>{
      getKnowledgeBaseSetting();
    },[])
    return (
        <header className="navbar sticky-top bg-white flex-md-nowrap p-2 align-items-center gap-5" id="HomeSbaTopBar">
          <div className="d-flex align-items-center w-50 gap-4">
                <h1 className="fs-6 fw-medium m-0 p-md-3 w-100">{process.env.REACT_APP_NEXTGEN_CLIENT_NAME}</h1>
              {/* <select  className="form-select" aria-label="Default select example" defaultValue={selectedOption} onChange={optionChange}> 
                {options.map((option) => (
                  <option key={option.value} value={option.value}>{option.label}</option>
                ))}
              </select> */}
              <SBAComboBox value={{ value: selectedOption, label: selectedOption }} data={options} textField={"label"} onChange={optionChange}  valueField={"value"}/>
              {selectedOption === "Family" ? (<>
                <div className="d-flex">
                  <button className={`rounded-start ${compositebuttonActive ? 'composite-toggle-btn' : 'portfolio-btn'}`} onClick={()=>CompositeValue()}type="button" >Composite</button>
                  <button className={`rounded-end ${portfoliobuttonActive ? 'composite-toggle-btn' : 'portfolio-btn'}`}  onClick={()=>PortfolioValue()} type="button" >Portfolio</button>
              </div>
            
              <SBAComboBox 
              value={selectedFamily} 
              data={familyList} 
              textField={"FamilyName"} 
              onChange={(e)=>{if(e.value)setSelectedFamily(e.value)}}  
              valueField={"FamilyId"}
              
              />

              </> ) :(
              <>
                            {selectedOption !== "Family"?<></>:(<>
                                <div className="d-flex">
                                    <button className="composite-toggle-btn rounded-start" type="button" disabled>Composite</button>
                                    <button className="portfolio-btn rounded-end" type="button" disabled>Portfolio</button>
                                </div>
                                <SBAComboBox
                                    value={selectedFamily}
                                    data={familyList}
                                    textField={"FamilyName"}
                                    onChange={(e) => { if (e.value) setSelectedFamily(e.value) }}
                                    valueField={"FamilyId"}
                                    disabled
                                />

                            </>)}
              </>
              )}
          </div>
          <div className="d-flex align-items-center">
          {globalVisible && <SearchContainner />}
              {/* <a href="#" className="ms-3"><img src={Filtericon} alt=""/></a> */}
              {!knowledgeBase && 
              <>
              <NotificationContainer/>
              <HelpContainer/>
              <ProfileContainer/>
              </>
              }
          </div>
        </header>
    )
};

